module.exports = __webpack_public_path__ + "static/img/bg_3.b167c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_3.png
// module id = H/wc
// module chunks = 0